import { useRef } from "react";
import {
	AlertDialog,
	AlertDialogBody,
	AlertDialogCloseButton,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button,
	Text,
} from "@chakra-ui/react";
import { useCart } from "../../hooks/cart";
import { useHistory } from "react-router-dom";

interface AlertResumeOrderParams {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
	pedido: any;
};

const AlertResumeOrder: React.FC<AlertResumeOrderParams> = ({
	isOpen,
	onRequestClose,
	pedido,
}) => {
	const cancelRef = useRef<any>(null);
	const { resumeCart } = useCart();
	const history = useHistory();

	return (
		<AlertDialog
			motionPreset='slideInBottom'
			size="sm"
			leastDestructiveRef={cancelRef}
			onClose={() => onRequestClose(false)}
			isOpen={isOpen}
			isCentered
		>
			<AlertDialogOverlay />

			<AlertDialogContent mx={["2", ""]}>
				<AlertDialogHeader>Retomar Pedido?</AlertDialogHeader>

				<AlertDialogCloseButton />

				<AlertDialogBody flexDir="column">
					<Text>Já existe um pedido em andamento!</Text>
					<Text>Deseja substituir o pedido em andamento?</Text>
				</AlertDialogBody>

				<AlertDialogFooter>
					<Button
						colorScheme="blackAlpha"
						ref={cancelRef}
						onClick={() => onRequestClose(false)}
					>
						Não
					</Button>

					<Button
						colorScheme="blue"
						ml={3}
						onClick={() => {
							resumeCart(pedido);
							onRequestClose(false);
							history.push('/products');
						}}
					>
						Sim
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}

export default AlertResumeOrder;